// @flow
import theme from "styled-theming";

const bodyBackgroundColor = theme("mode", {
  light: "#FFFFFF",
  dark: "#090909",
});

const boxBackgroundColor = theme("mode", {
  light: "#FCFCFC",
  dark: "#000000",
});

const fontSize = theme("text", {
  small: "12px",
  normal: "14px",
  large: "16px",
});

const secondaryTextColor = theme("mode", {
  light: "#434343",
  dark: "#7d7d7d",
});

const textColor = theme("mode", {
  light: "rgba(0, 0, 0, 0.85)",
  dark: "rgba(255, 255, 255, 0.85)",
});

export {
  bodyBackgroundColor,
  boxBackgroundColor,
  fontSize,
  secondaryTextColor,
  textColor,
};
